import React, { useReducer, useEffect, useState } from "react"

import Layout from "../../../components/layout/layout"
import HowItWorks from "../../../components/cards/howitworks/HowItWorks"
import OurSolutions from "../../../components/solutions/Solutions"
import Clients from "../../../components/cards/clients"
import TestimonialSection from "../../../components/homepage/testimonials"
import Features from "../../../components/cards/features/Features"
import InquireSection from "../../../components/cards/inquire/InquireSection"
import OtherProducts from "../../../components/cards/relatedarticles/RelatedArticles"
import { getCountryCallingCode } from "react-phone-number-input"
import banner from "./banner.png"
import feature1 from "./feature-1.svg"
import feature2 from "./feature-2.svg"
import feature3 from "./feature-3.svg"
import feature4 from "./feature-4.svg"
import {
  otherProducts,
  productFaq,
  formatNumber,
  validateEmail,
} from "../../../utils"
import { requestService } from "../../../services"
import SEO from "../../../components/seo"
import SucessModal from "../../../components/modals/successModal/successModal"
import BookingSection from "../../../components/serviceCards/bookingSection/index.jsx"

const PreX = ({ location: { pathname } }) => {
  const [details, setDetails] = useReducer(
    (state, newState) => ({
      ...state,
      ...newState,
    }),
    {
      phone: "",
      name: "",
      email: "",
      company: "",
      comments: "",
      designation: "",
      country_code: "+1",
      requesting: false,
      response: "",
      terms: false,
      submitted: false,
    }
  )
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const data = {
    title: "Deliver the knockout \nuser experience that \ndelights shoppers",
    bannerImage: banner,
    desc:
      "The AI based product recommendation engine successfully deliver hyper personalization to every shopper based on the buying behavior and affinity to purchase a particular product",
    overview: "P-rex Overview",
    overviewText:
      "The proprietary product recommendation engine helps you to deliver next level engagement with personalization of products displayed. It analyzes the behavior of your visitors and adjusts your products in real-time so that each customer gets their own version of the recommended products, highlighting the products that they are most likely to buy, based on their preferences and digital footprint. Our machine learning algorithm collects customer data such as which products they look at, past purchases, and which they spend the most time on. With such insights, the tool then lists only those products that are considered relevant to the shopper preferences. This customization of product lineup boosts shopper engagement, unlocks cross-selling opportunities, and provides a competitive advantage with loyal shoppers.",
    features: [
      {
        title: "Improve Average Order \nValue",
        description:
          "Personalization of products enables better cross-selling and upselling \npotential. This will see an uptick in revenues without having to invest in \ngetting more traffic to the site.",
        featureImage: feature1,
        imagePosition: "right",
      },
      {
        title: "Total value for every \nminute spent",
        description:
          "Shoppers need not be diverted by products they aren’t interested in. They \nget to see only those products that are relevant to their purchase \npreferences or buying history.",
        featureImage: feature2,
        imagePosition: "left",
      },
      {
        title: "Boost conversion rate",
        description:
          "Since customers get to see only products that are relevant to \ntheir search and buying history,the likelihood of successful \nsale shoots up dramatically.",
        featureImage: feature3,
        imagePosition: "right",
      },
      {
        title: "Total flexibility on \nweb layout",
        description:
          "Easily insert personalized recommendations anywhere – on a menu, the homepage, cart \npages,product pages, mobile apps, display banners, and inside emails.",
        featureImage: feature4,
        imagePosition: "left",
      },
    ],
    subSectionTitle: "Explore P-reX",
    platformText:
      "Pre-X looks at various variables like past shopping behaviors and where they spend their \nshopping time on. This data is then utilized to show most relevant products in real-time so that \nshoppers get maximum value for the time they spend on your site.",
  }
  const handleNumberSelect = value => {
    setDetails({ phone: value })
  }
  useEffect(() => {
    let timeout
    if (details.response) {
      setShowSuccessModal(true)
      timeout = setTimeout(() => {
        setShowSuccessModal(false)
        setDetails({ response: "" })
      }, 5000)
    }
    return () => {
      clearTimeout(timeout)
    }
  }, [details.response])
  const getCountryCode = value => {
    let countryCode = value && getCountryCallingCode(value)
    setDetails({ country_code: `+${countryCode}` })
  }
  const onChange = e => {
    const { name, value } = e.target
    setDetails({ [name]: value })
  }
  const onCheck = e => {
    setDetails({ terms: e.target.checked })
  }
  const submit = async () => {
    setDetails({ submitted: true })
    const {
      name,
      phone,
      email,
      company,
      comments,
      designation,
      country_code,
      terms,
    } = details
    let data
    if (
      name !== "" &&
      phone !== "" &&
      email !== "" &&
      company !== "" &&
      comments !== "" &&
      designation !== "" &&
      validateEmail(email)
    ) {
      if (!terms) {
        alert("please accept our terms and conditions")
        return
      }
      let number = formatNumber(phone)
      data = {
        form_name: "contact form",
        page_url: pathname,
        section_name: "prex",
        name,
        company_name: company,
        designation,
        email,
        country_code,
        phone_number: number,
        your_message: comments,
      }
      // console.log(data)
      try {
        setDetails({ requesting: true })
        let result = await requestService.productForm(data)
        setDetails({
          phone: "",
          name: "",
          email: "",
          company: "",
          comments: "",
          designation: "",
          country_code: "",
          requesting: false,
          terms: false,
          response: result && result.more_info,
          submitted: false,
        })
      } catch (err) {
        console.log(err)
        setDetails({ requesting: false })
      }
    }
  }
  return (
    <Layout withBrand slidePosition={0} btnBg="#FED100" btnColor="#000000">
      {showSuccessModal && <SucessModal show={showSuccessModal} />}
      <SEO
        title="Wersel PriceX - Result-oriented pricing intelligence tool now available "
        keywords="pricing intelligence platform, pricing intelligence software, ecommerce pricing intelligence, ecommerce pricing monitoring tool "
        description="The only price intelligence software you would need to know the pulse of the market in real-time. Don’t let competitor price updates lead to revenue loss. Get to know the relevant prices listed on competitor sites and get these automatically updated on your site too. "
        url="www.wersel.io/products/prex"
      />
      <OurSolutions data={data} btnBg="#FED100" btnColor="#000000" />
      <Features title="P-reX Features" features={data.features} />
      <BookingSection
        howItWorksTitle="Sell more, serve shoppers better with personalized recommendations"
        howItWorks="Get Pre-X to leverage machine learning and fast-track successful conversions"
      />
      <Clients title="We gave solutions for" />
      <InquireSection
        withoutFaqText
        btnBg="#FED100"
        btnColor="#000000"
        faq={productFaq}
        handleNumberSelect={handleNumberSelect}
        getCountryCode={getCountryCode}
        details={details}
        onChange={onChange}
        submit={submit}
        onCheck={onCheck}
      />
      {/* <TestimonialSection /> */}
      <OtherProducts path={pathname} title="Products" posts={otherProducts} />
    </Layout>
  )
}

export default PreX
